// Endpoint backend (PHP + PHPMailer) — même domaine en dev (proxy) et en prod.
const ENDPOINT = '/api/submit.php';

export async function sendFormJSON(formEl, formId) {
  const data = Object.fromEntries(new FormData(formEl));
  if (formId) data.formId = formId;
  data.website = data.website || ""; // honeypot
  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  const out = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(out.message || 'Erreur réseau');
  return out;
}

export async function sendFormData(payload, formId) {
  const data = { ...payload };
  if (formId) data.formId = formId;
  if (typeof data.website === 'undefined') data.website = ""; // honeypot
  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  const out = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(out.message || 'Erreur réseau');
  return out;
}


